import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { HelpCenterCategory } from '../models/helpCenterCategory';
import { HelpCenterCrumb } from '../models/helpCenterCrumb';
import { HelpCenterSection } from './groupHelpCenterCategories';

/**
 * Brödsmulorna för en kategori: huvudkategorin som text, sedan kategorin, eller bara huvudkategorin när det är dess
 * egna artiklar. Kategorin länkar till sin sida när det inte är den sista brödsmulan, t.ex. under en artikel.
 */
export const getHelpCenterTrail = (section: HelpCenterSection | undefined, category: HelpCenterCategory | undefined): HelpCenterCrumb[] => {
  if (!section || !category) return [];

  const categoryCrumb = { key: `category-${category.id}`, label: category.name, to: `${RoutesEnum.HelpCategory}/${category.id}` };

  if (section.mainCategory.id === category.id) return [categoryCrumb];

  return [{ key: `category-${section.mainCategory.id}`, label: section.mainCategory.name }, categoryCrumb];
};
